import PropTypes from 'prop-types';
import InstallPLuginCheck from '../InstallPluginCheck';
import { memo } from 'react'

 function SecondaryTitle({checked, text, showCheckState}) {
  return (
    checked ?
      <InstallPLuginCheck text={text}></InstallPLuginCheck> :
      <>      
        {showCheckState && <div className="empty-circle"></div>}
        <span>{text}</span>     
      </>      
  )
 }

SecondaryTitle.propTypes = {
  showCheckState: PropTypes.bool,
  text: PropTypes.string,
  checked: PropTypes.bool
};

SecondaryTitle.defaultProps = {
  checked: false,
  showCheckState: true
}

export default memo(SecondaryTitle);